import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './app';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Uploader } from './features/uploader/uploader';
import { Modal } from './features/modal/modal';
import { UploaderQueueProcessor } from './features/uploader/uploader-queue-processor';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://2dc9585668a4ce179b075abcbcb5e23b@o79871.ingest.us.sentry.io/4508225255768064',
  integrations: [],
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <UploaderQueueProcessor>
        <App />
        <ToastContainer />
        <Uploader />
        <Modal />
      </UploaderQueueProcessor>
    </Provider>
  </BrowserRouter>
);
